export function buildOssVideoCoverUrl(url) {
  return `${url}?x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast`
}
